import React from 'react';
import Reveal from './Reveal';

const heroStats = [
    { value: '23', label: 'Municípios integrados' },
    { value: '2025-2027', label: 'Gestão regional' },
    { value: 'Rede', label: 'Suporte técnico e político' },
];

const heroActions = [
    {
        href: '#municipios',
        icon: 'fas fa-map-marked-alt',
        label: 'Ver municípios',
        className: 'bg-brand-yellow text-brand-darkGreen shadow-[0_12px_30px_rgba(254,193,14,0.25)] hover:bg-yellow-300',
    },
    {
        href: '#contato',
        icon: 'fab fa-whatsapp',
        label: 'Filiar conselho',
        className: 'bg-white/10 text-white border border-white/25 hover:bg-white/15',
    },
];

const Hero: React.FC = () => {
    return (
        <section className="relative flex min-h-[calc(100svh-3rem)] items-center overflow-hidden bg-brand-darkGreen pt-24 pb-10 text-white lg:min-h-[calc(100svh-4rem)] lg:pt-28 lg:pb-12">
            <div
                className="absolute inset-0 z-0 pointer-events-none"
                style={{
                    backgroundImage: "url('https://images.unsplash.com/photo-1544531586-fde5298cdd40?q=80&w=2070&auto=format&fit=crop')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            ></div>

            <div className="absolute inset-0 z-0 bg-[linear-gradient(112deg,rgba(0,66,37,0.96)_0%,rgba(0,104,55,0.9)_45%,rgba(0,66,37,0.82)_100%)]"></div>
            <div className="absolute inset-0 z-0 bg-[radial-gradient(rgba(255,255,255,0.12)_1px,transparent_1px)] bg-[length:28px_28px] opacity-20"></div>

            <div className="container relative z-10 mx-auto px-4">
                <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[minmax(0,1.02fr)_minmax(320px,0.98fr)] xl:gap-10">

                    <div className="relative z-20 text-left">
                        <Reveal>
                            <div className="mb-4 inline-flex items-center gap-2 rounded-lg border border-white/20 bg-white/10 px-3 py-2 text-xs font-semibold uppercase tracking-wider backdrop-blur-md">
                                <span className="w-2 h-2 rounded-full bg-brand-yellow animate-pulse"></span>
                                <span>Gestão 2025 - 2027</span>
                            </div>
                        </Reveal>

                        <Reveal delay={200}>
                            <h1 className="mb-4 text-4xl font-extrabold leading-[1.02] tracking-normal sm:text-5xl lg:text-[4.1rem] xl:text-[4.6rem]">
                                ACONTURS<br />
                                <span className="text-brand-yellow">
                                    Litoral Norte
                                </span>
                            </h1>
                        </Reveal>

                        <Reveal delay={400}>
                            <h2 className="mb-5 block border-l-4 border-brand-yellow pl-4 text-lg font-semibold text-slate-100 lg:text-xl">
                                Representatividade e Apoio Técnico
                            </h2>
                        </Reveal>

                        <Reveal delay={600}>
                            <div className="mb-6 max-w-xl text-base leading-relaxed text-slate-200 lg:text-lg">
                                <p>Unindo e fortalecendo os 23 Conselhos Tutelares do litoral gaúcho. Defendendo quem defende direitos.</p>
                            </div>
                        </Reveal>

                        <Reveal delay={800}>
                            <div className="mb-7 grid max-w-xl grid-cols-1 gap-3 sm:grid-cols-3">
                                {heroStats.map((stat) => (
                                    <div key={stat.label} className="rounded-lg border border-white/15 bg-white/10 px-4 py-3 backdrop-blur-sm">
                                        <strong className="block text-xl font-extrabold text-brand-yellow">{stat.value}</strong>
                                        <span className="mt-1 block text-xs font-medium leading-snug text-white/75">{stat.label}</span>
                                    </div>
                                ))}
                            </div>
                        </Reveal>

                        <Reveal delay={900}>
                            <div className="flex flex-col gap-3 sm:flex-row">
                                {heroActions.map((action) => (
                                    <a
                                        key={action.href}
                                        href={action.href}
                                        className={`btn-shine flex items-center justify-center gap-2 rounded-lg px-5 py-3 text-sm font-extrabold uppercase tracking-wider transition hover:-translate-y-0.5 ${action.className}`}
                                    >
                                        <i className={action.icon}></i>
                                        {action.label}
                                    </a>
                                ))}
                            </div>
                        </Reveal>
                    </div>

                    <div className="relative z-10 hidden h-full items-center justify-center lg:flex">
                        <div className="relative z-10 flex w-full max-w-[430px] items-center justify-center xl:max-w-[500px]">
                            <img
                                src="assets/mapa.svg"
                                alt="Mapa do Rio Grande do Sul"
                                className="h-auto max-h-[340px] w-auto max-w-full object-contain drop-shadow-2xl xl:max-h-[410px]"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
